"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const react_1 = __importDefault(require("react"));
const displayWrapper_1 = require("./common/displayWrapper");
const components_1 = require("utils/components");
const TableSchemaComponent = (props) => {
    return react_1.default.createElement(react_1.default.Fragment, null);
};
TableSchemaComponent.display = (0, displayWrapper_1.DisplayComponent)("TableDisplayComponent", (value, schema) => {
    if (!value) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const columns = Object.keys(value[0]).map((key) => ({
        accessor: key || "",
        Header: key,
        Cell: ({ row }) => {
            return react_1.default.createElement("span", null, (0, lodash_1.get)(row.original, key));
        },
    }));
    return react_1.default.createElement(components_1.Table, { columns: columns, data: value, pageSize: schema.pageSize });
});
exports.default = TableSchemaComponent;
